/** Small key/value facts about this device's sync state (last success, etc.). */
import { db } from './db';

export async function getValue<T>(key: string): Promise<T | undefined> {
  const record = await db.kv.get(key);
  return record?.value as T | undefined;
}

export async function setValue(key: string, value: unknown): Promise<void> {
  await db.kv.put({ key, value });
}
